import { createContext, Dispatch } from "react";
import { AllLayouts } from "./models";

export interface LayoutItem {
  config: any;
  layoutName: string;
}

export interface SiteConfig {
  layoutConfig: any;
  setLayoutConfig?: Dispatch<any>;
  allLayouts: AllLayouts;
}

export const ConfigContext = createContext({
  layoutConfig: null,
});
